import { Container, Row, Col } from "react-bootstrap";
import useMediaQuery from "../hooks/useMediaQuery";
import Typography from "./Typography/Typography";
import Animation from "../animations/Animation";

const BottomBanner = (props) => {
   const lgBreakpoint = useMediaQuery("(min-width: 991px)");
   const backgroundStyles = {
      backgroundImage: `url(${props.image})`,
      minHeight: props?.height || "auto",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
   };
   return (
      <Container fluid>
         <Row style={backgroundStyles} className="justify-content-center align-items-center">
            <Col xs={12} sm={12} md={10} lg={11} xl={11} className="text-center">
               <Animation slide bottom>
                  <Typography element="h5" fontWeight={600} syne className="colorWhite fs60 lh80 mobLineHeight mobMt0 mt20 mobMb15 mobHeadingFontSize tabHeadingFontSize">
                     {props.title}
                  </Typography>
                  <Typography element="p" className="mt30 mb30 mobMt10 mobMb10 colorWhite fs18" DMSans>
                     {props.description}
                  </Typography>
               </Animation>
               <Animation slide bottom>
                  {props?.extra && props?.extra}
               </Animation>
            </Col>
         </Row>
      </Container>
   );
};

export default BottomBanner;
